export default function(nga, admin) {
    let entity = admin.getEntity('invoice')
        //.updateMethod('patch')
        .label('invoice')

    let pad = function (n, width, z) {
        z = z || '0';
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    }

    entity.listView()
        .fields([
            nga.field('numeration').label('NUMERATION'),
            nga.field('owner').label('OWNER').map(function (value, entry) {
                return entry['owner.name'] + ' ' + (entry['owner.surname'] || '');
            }).template('<entity-show type="\'user\'" id="entry.values[\'owner.id\']" text="value"></entity-show>'),
            nga.field('status').label('STATUS'),
            nga.field('product_name').label('PRODUCT'),
            nga.field('price').label('PRICE'),
            nga.field('created','date').label('CREATED').format('yyyy-MM-dd'),
        ])
        .url('invoices')
        .permanentFilters({
            payment: false
        })
        .listActions(['<invoice-download entry="entry" entity="entity"/>', '<invoice-resend entry="entry" entity="entity"/>','edit', 'delete', '<invoice-payment entry="entry" entity="entity"/>'])
        .filters([
            nga.field('q', 'template')
                .label('')
                .pinned(true)
                .template('<div class="input-group"><input type="text" ng-model="value" placeholder="Search order" class="form-control"></input><span class="input-group-addon"><i class="glyphicon glyphicon-search"></i></span></div>'),
            nga.field('status', 'choice')
                .choices([
                    { label: 'active', value: '1' },
                    { label: 'inactive', value: '0' }
                ]),
        ]);

    entity.editionView().fields([
        nga.field('numeration').label('NUMERATION'),
        nga.field('payment', 'boolean').label('PAYMENT')
            .template('<ma-switch-field field="::field" value="value" entry="::entry"></ma-switch-field>'),
        nga.field('owner', 'reference')
            .map(function(value, entry) {
                return entry['owner.id'];
            })
            .targetEntity(nga.entity('professional').url('professionals'))
            .targetField(nga.field('name'))
            .perPage(0),
        nga.field('status').label('STATUS'),
        nga.field('created', 'date').format('yyyy-MM-dd').map(ParseDate),
        nga.field('updated', 'date').format('yyyy-MM-dd').map(ParseDate),
        nga.field('purchase', 'reference')
            .map(function(value, entry) {
                return entry['purchase.id'];
            })
            .targetEntity(nga.entity('purchase').url('purchases'))
            .targetField(nga.field('order'))
            .perPage(0),
        nga.field('product_name').label('PRODUCT'),
        nga.field('price').label('PRICE'),
    ]);


    entity.creationView().fields(
        entity.editionView().fields()
    );

    entity.deletionView();

    return entity;
}



/** WEBPACK FOOTER **
 ** ./js/entities/invoice/config.js
 **/